'use client';

import { useState } from 'react';

export function LoginForm({ next }: { next: string }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setBusy(true);
    setError('');
    const form = new FormData(e.currentTarget);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: form.get('username'), password: form.get('password') }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.error ?? 'No se pudo iniciar sesión');
        setBusy(false);
        return;
      }
      window.location.assign(next);
    } catch {
      setError('No se pudo conectar con el servidor');
      setBusy(false);
    }
  }

  return (
    <form className="stack" onSubmit={onSubmit}>
      <label className="field">
        Usuario
        <input name="username" autoComplete="username" autoCapitalize="none" required autoFocus />
      </label>
      <label className="field">
        Contraseña
        <input name="password" type="password" autoComplete="current-password" required />
      </label>
      {error && <div className="msg error" role="alert">{error}</div>}
      <button className="btn" type="submit" disabled={busy}>
        {busy ? 'Entrando…' : 'Entrar'}
      </button>
    </form>
  );
}
